export const config = {
  apiKey: "AIzaSyA2sI6r3_WJE3ioYvU4HDMH9TOSgDe4a6w",
  authDomain: "tma1-products.firebaseapp.com",
  databaseURL: "https://tma1-products.firebaseio.com",
  projectId: "tma1-products",
  storageBucket: "tma1-products.appspot.com",
  messagingSenderId: "644029729937",
  appId: "1:644029729937:web:644ebe472c8115a29a8330"
};

export const shouldUseEmulator = false;
